import { Controller } from "stimulus"
import { ScrollSpy } from "bootstrap"

export default class extends Controller {
  static targets = [ "contentNav" ]

  connect () {
    this.scrollScheduled = false
    this.scrollSpy = this.hasContentNavTarget && new ScrollSpy(document.body, {
      target: this.contentNavTarget,
      offset: 200
    })

    // Same scheduler as scroll events so an early onScroll cannot queue a second RAF.
    this.onScroll()
  }

  disconnect () {
    if (this.scrollSpy) this.scrollSpy.dispose()
  }

  scroll (event) {
    document.querySelector(event.currentTarget.attributes.href.value).scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  onScroll (_event) {
    if (this.scrollScheduled) return
    this.scrollScheduled = true

    requestAnimationFrame(() => {
      this.scrollScheduled = false
      this.handleScroll()
    })
  }

  handleScroll () {
    const scrolled = window.scrollY > 0
    this.element.classList.toggle('shadow-sm', scrolled)
    this.element.classList.toggle('border-bottom', scrolled)

    if (!this.hasContentNavTarget) return

    // Absolute page Y of the inline nav; sticky content nav stays hidden until scroll passes it.
    const threshold = document.querySelector('.inline-navbar').getBoundingClientRect().top + window.scrollY
    this.contentNavTarget.classList.toggle('d-none', window.scrollY <= threshold)
  }
}
